/* schema.org BreadcrumbList payload builder.
 *
 * Google replaces the ugly URL crumbs in the SERP with the named ones from
 * this schema (e.g. "ZHELTA › Systems › Managed IT Services" instead of
 * "zhelta.com › systems › solutions › managed-it-services"). Higher CTR on
 * every long-tail detail-page result.
 *
 * Usage:
 *   getBreadcrumbSchema([
 *     { name: 'Home', path: '/' },
 *     { name: 'Systems', path: '/systems' },
 *     { name: 'Managed IT Services', path: '/systems/solutions/managed-it-services' },
 *   ])
 */

export function getBreadcrumbSchema(items, origin) {
  if (!Array.isArray(items) || items.length === 0) return null;
  const safeOrigin = origin || (typeof window !== 'undefined' ? window.location.origin : 'https://zhelta.com');

  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map((it, i) => ({
      '@type': 'ListItem',
      position: i + 1,
      name: it.name,
      item: `${safeOrigin}${it.path || '/'}`,
    })),
  };
}
